import React from 'react'

import PropTypes from 'prop-types'

import CheckList from './CheckList'
import { CLASS_YEARS, CLASS_YEARS_LABELS } from './classyears-service'

export const SegmentName = 'CurrentGradYearOffset'
export const Criteria = 'Must'

const ClassYearSelector = ({ years, onChange }) => {
  const checkedYears = {}
  years.forEach((y) => (checkedYears[y] = true))
  return (
    <CheckList
      selectedValues={years}
      labels={CLASS_YEARS_LABELS}
      values={CLASS_YEARS}
      onChange={onChange}
      required
    />
  )
}

ClassYearSelector.propTypes = {
  years: PropTypes.array.isRequired,
  onChange: PropTypes.func.isRequired,
}

ClassYearSelector.defaultProps = {
  years: [],
}

export default ClassYearSelector
